import { j as m } from "../../../jsx-runtime-B6kdoens.js";
import { c as u } from "../../../index-CROKJrb5.js";
import { c as i, f as l } from "../../../create-component-CBAeEoQ6.js";
import { useModalStateAtoms as f } from "../ModalState/index.js";
import { u as p } from "../../../react-B_GApDuV.js";
const d = u({
  base: "cur-grow cur-shrink cur-basis-0 cur-h-0 cur-overflow-auto",
  variants: {
    contentStyle: {
      card: "cur-bg-surface-neutral cur-p-4"
    }
  }
}), b = i(
  "ModalContent",
  l(
    ({ as: t, children: o, className: r, ...s }, e) => {
      const a = t || "div", { contentStyleAtom: n } = f(), c = p(n);
      return /* @__PURE__ */ m.jsx(
        a,
        {
          ref: e,
          className: d({
            className: r,
            contentStyle: c
          }),
          ...s,
          children: o
        }
      );
    }
  )
);
export {
  b as ModalContent
};
//# sourceMappingURL=index.js.map
